<template>
  <div>
    <div class="home-head home-head-page">
      <TopHeader></TopHeader>
    </div>
    <div class="case case3 caseContain">
      <div class="caseTitle">
        <div class="container">
          <h3>应用案例</h3>
          <ul>
            <li class="caBg1">
              <a @click="gotoCase1" herf="#">
                <span>
                  <em>IDC服务商</em>
                  <i>IDC机房运维分析监控</i>
                </span>
              </a>
            </li>
            <li class="caBg2">
              <a @click="gotoCase2" herf="#">
                <span>
                  <em>
                    某上市
                    <b class="pSec"></b>零售企业
                  </em>
                  <i>
                    全业务可视化
                    <b class="pSec"></b>统计分析
                  </i>
                </span>
              </a>
            </li>
            <li class="caBg6">
              <a @click="gotoCase3_1" herf="#">
                <span>
                  <em>
                    某交通管理部门
                    <b class="pSec"></b>
                  </em>
                  <i>交通流量业务可视化统计分析</i>
                </span>
              </a>
            </li>
            <li class="caBg3 active">
              <a @click="gotoCase4" herf="#">
                <span>
                  <em>运营商</em>
                  <i>
                    用户标签可视化
                    <b class="pSec"></b>聚合分析
                  </i>
                </span>
              </a>
            </li>
            <li class="caBg4">
              <a @click="gotoCase3_2" herf="#">
                <span>
                  <em>某海事局</em>
                  <i>船舶追越分析</i>
                </span>
              </a>
            </li>
            <li class="caBg5">
              <a @click="gotoCase3_3" herf="#">
                <span>
                  <em>
                    智能电网
                    <b class="pSec"></b>运检
                  </em>
                  <i>
                    -大数据设备画
                    <b class="pSec"></b>像及应用
                  </i>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="caseDetail">
        <div class="container">
          <div class="caseDetailS">
            <span class="caseImg">
              <span></span>
              <em>运营商</em>
              <i>—用户标签可视化聚合分析</i>
              <b></b>
            </span>
            <div class="caseCon">
              <div class="cPage1">
                <h4>项目背景</h4>
                <p>某通讯公司拥有ISP和ICP服务资质，承接了大量企业，办公楼宇的互联网管道接入，数据托管等互联网增值业务，拥有大量优质用户动态信息数据。但是对于这些数据如何还原用户信息，标签归类用户，将数据使用在在活动推广，精准广告投放领域，并没有合适的手段，数据价值并没有得到充分的发挥。</p>
                <p>考虑到我们在大数据聚合分析方面的算法、性能、安全和可视化优势，可以为他们快速准确的建立用户画像系统，使他们的数据能够发挥最大价值。</p>
              </div>
              <div class="cPage2">
                <h4>需求理解</h4>
                <h5>从背景上来看，该用户的需求分为以下几个方面：</h5>
                <ol type="1">
                  <li>把用户行为数据进行准确的拆包，解析和整理；</li>
                  <li>对大容量的用户行为数据进行可靠和安全的存储；</li>
                  <li>建立并不断快速迭代用户标签库；</li>
                  <li>通过可靠算法关联用户数据和标签库，完成用户画像；</li>
                  <li>用户画像的可视化展示。</li>
                </ol>
                <h5 class="caseh">通过各个模块的功能拼装，我们迅速就实现了客户的需求</h5>
              </div>
              <div class="cPage3">
                <h4>目标与价值</h4>
                <table>
                  <thead>
                    <tr>
                      <th>目标</th>
                      <th>价值</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          <i class="K56"></i>用户行为数据的准确拆分和整
                          <i class="pSec"></i>理，拆分后大数据量的储存
                        </p>
                      </td>
                      <td>
                        <p>
                          去除冗余数据，提升核心数据的辨识度，提高数据查
                          <i class="pSec"></i>询效率和准确性。
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <i class="K56"></i>用户标签库和核心算法库的建
                          <i class="pSec"></i>立，用户数据与标签库的完美关
                          <i class="pSec"></i>联
                        </p>
                      </td>
                      <td>
                        <p>
                          完美关联用户行为信息抽象用户信息全貌，提高活动
                          <i class="pSec"></i>精准推送和广告精确投放成功率。
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <i class="K56"></i>核心数据私有化部署、在各种平
                          <i class="pSec"></i>台上进行可视化展示
                        </p>
                      </td>
                      <td>
                        <p>
                          确保核心数据私密性和安全性，提升数据展示的即时
                          <i class="pSec"></i>性和灵活性。
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<style scoped>
.case {
  color: #000000;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
</style>

<script>
import TopHeader from "../../../common/compoments/TopHeader";
import Footer from "../components/Footer.vue";
export default {
  name: "case4",
  components: {
    TopHeader,
    Footer
  },
  data() {
    return {};
  },
  created: function() {},
  mounted: function() {
    this.$nextTick().then(
      function() {
        var loginR = document
          .getElementsByClassName("right-selection")[0]
          .getElementsByTagName("div");
        loginR[0].className = "new_login new_login_bcon3";
        loginR[1].className = "new_login new_login_bcon4";
      }.bind(this)
    );
  },
  methods: {
    gotoAbout: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "about" });
    },
    gotoScenarios: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "scenarios" });
    },
    gotoCase1: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "case1" });
    },
    gotoCase2: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "case2" });
    },
    gotoCase3_1: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "case3_1" });
    },
    gotoCase3_2: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "case3_2" });
    },
    gotoCase3_3: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "case3_3" });
    },
    gotoCase4: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "case4" });
    }
  }
};
</script>
